import { ImmutableMap, QueryParams } from '@daikin-tic/dxone-com-lib';

import { Unit } from './unit.model';

export const YES_NO_VALUE_EN = ['yes', 'no'] as const;
export const YES_NO_VALUE_DE = ['ja', 'nein'] as const;
export const YES_NO_VALUE_JA = ['OK', 'NG'] as const;
export const YES_NO_VALUE = [...YES_NO_VALUE_EN, ...YES_NO_VALUE_DE, ...YES_NO_VALUE_JA] as const;
export type YesNoValue = (typeof YES_NO_VALUE)[number];

type ProjectRequiredProps = {
  name: string;
  site: string;
  scheduledAt: number;
};

type ProjectOptionalProps = {
  remarks?: string;
};

type ProjectProvidedProps = {
  projectId: string;
  units?: Unit[];
  createdAt: number;
  updatedAt: number;
  version: number;
  author: string;
  assignedUsers: string[];
};

export type ProjectQueryParams = QueryParams & { scheduledFrom: string; scheduledTo: string };

export type Project = ProjectRequiredProps & ProjectOptionalProps & ProjectProvidedProps;

export class Projects extends ImmutableMap<string, Project> {
  constructor(projects?: Project[] | Iterable<Project>) {
    super((project: Project) => project.projectId, projects);
  }

  protected clone(projects?: Project[] | Iterable<Project>): this {
    return new Projects(projects) as this;
  }
}
